import React, { useEffect , useState } from "react"
import { Container } from "react-bootstrap"
import HTMLReactParser from 'html-react-parser';
//import ScrollAnimation from "react-animate-on-scroll";
import axios from "axios";
import "./Counter.scss"

const Counter = (props) => { 
let [latestReview, setReviews] = useState(typeof props.reviews != "undefined" ? props.reviews : []);
const wordToNumber = { 'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5 };
let [reviewCount, setReviewCount] = React.useState(typeof props.reviewCount != "undefined" ? props.reviewCount : 0);
let [averageRating, setAverageRating] = React.useState(typeof props.averageRating != "undefined" ? props.averageRating : 0);
  const [renderComponent, setRenderComponent] = useState(false);
    useEffect(()=>{
      let url = `${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`
      window.addEventListener("mousemove", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })
      window.addEventListener("keypress", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })
      window.addEventListener("touchmove", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })

      if( latestReview.length == 0){
        getitems(url);
      }
    })
    const strapiconfig = {
      headers: {
          Authorization:
              `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
      },
    }

  const getitems = async url => {
    try {
      const { data } = await axios.get(url,strapiconfig)// could be from env files 
      setReviewCount(data.length);  
      let sumOfScores = 0; 
      data.map((review) => {
        const reviewStringValue = review.starRating;
        sumOfScores += wordToNumber[reviewStringValue]; 
      })
      setAverageRating(Math.round(sumOfScores / data.length * 10) / 10); 
    } catch (error) {
      console.error(error)  
    }
  }
    return (
        <section className={`counter sec-pdy-120 ${props.page === 'Home' ? 'home-counter' : 'landing-counter'}`}>
            <Container>
                <div className="counter-wrapper">
                    <div className="row">
                    {props.stats && props.stats.map((stat, i) => {  
                        return (
                        <div className="col-12 col-md-6 col-xl-3">
                        <div className="record-wrap">
                            <div className="total-record">
                                <span className="count-heading h1"> 
                                {
                                    stat.Value == "google_review_average" ? `${averageRating}/5` : stat.Value
                                }
                                </span>
                                <p className="text-sm mb-0">
                                {
                                    stat.Value == "google_review_average" ? <p>{averageRating} average Google Review score</p>: HTMLReactParser(stat.Content.replace(/\n/g,'<br />'))
                                } 
                             </p>
                            </div>
                            </div>
                        </div>
                        )
                    })}
                    </div>
                    
                </div>
          
            </Container>
            
        </section>
    )
};
export default Counter